import React from 'react';
import { PotOfGoldProps } from '../../index';

const CommonClassName = `css-backdrop absolute top-46 object-cover transition-opacity duration-500 ease-in-out -translate-y-96 w-[calc(100vw_+_3rem)] left-1/2 -translate-x-1/2 
        is-desktop-detected:w-screen is-desktop-detected:top-0`;

export type BackdropProps = PotOfGoldProps & {
    src: string;
    className?: string;
    gradient?: boolean;
    blur?: boolean;
}

const GetSvg = (Svg: string, className: string, gradient: boolean) => React.cloneElement(<Svg />, {
  className: `${CommonClassName} h-384 md:h-512 ${gradient ? 'mask-gradient--potofgold' : ''} ${className}`
});

export const Backdrop = ({
  src,
  className = '',
  gradient = true,
  blur = true,
  isPotOfGold
}: BackdropProps) => (isPotOfGold ? GetSvg(src, className, gradient) : (
  <img alt='background image'
    src={src}
    className={`${CommonClassName} h-[calc(100%+96px)] ${gradient ? 'mega-gradient' : ''} ${blur ? 'blur' : ''} ${className}`}
  />
));
